//Views
PJQ.views.reporting = {};
//This will be remade into a right bar menu when the project wall is redesigned
//Right now (1/22/2019) a left bar doesnt work with the design of the project wall
PJQ.views.reporting.GenerateReportModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Generate-Report'),
		subTemplates: {
			reportOption: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Generate-Report-Option'),
		},
		onDownload: null
	},
	events: {
		'click .modal-report-download': 'onDownload'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		_.each(this.model.get('options'), _.bind(function (option) {
			this.renderSubTemplate(true, this.options.subTemplates.reportOption, this.$('.report-options-outer'), {
				option: option
			}, function (content) {
				switch (option.type) {
					case 'DATE_RANGE':
						new PJQ.inputs.Datepicker({
							el: content.find('.input-date-from'),
							datepickerOptions: {
								defaultDate: option.defaultValue ? option.defaultValue.from : null,
								format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
							},
							onChange: function (value) {
								if (typeof option.value !== 'object') {
									option.value = {};
								}
								option.value.from = value;
							}
						});
						new PJQ.inputs.Datepicker({
							el: content.find('.input-date-to'),
							datepickerOptions: {
								defaultDate: option.defaultValue ? option.defaultValue.to : null,
								format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
							},
							onChange: function (value) {
								if (typeof option.value !== 'object') {
									option.value = {};
								}
								option.value.to = value;
							}
						});
						break;
				}
			});
		}, this));
	},
	onDownload: function () {
		let isValid = true;
		_.each(this.model.get('options'), _.bind(function (option) {
			if (option.isRequired) {
				let isOptionValid = true;
				switch (option.type) {
					case 'DATE_RANGE':
						let to = (option.value != null ? option.value.to : null),
							from = (option.value != null ? option.value.from : null),
							isToValid = (to != null && from < to),
							isFromValid = (from != null && from < to);
						PJQ.helpers.inputHelpers.setInputError(this.$('.input-date-from[data-cid="' + option.id + '"]'), isFromValid);
						PJQ.helpers.inputHelpers.setInputError(this.$('.input-date-to[data-cid="' + option.id + '"]'), isToValid);
						isOptionValid = (isFromValid && isToValid);
						break;
				}

				if (!isOptionValid) {
					isValid = false;
				}
			}
		}, this));
		if (isValid && typeof this.options.onDownload === 'function') {
			let loader = new PJQ.Loader(this.$('.modal-content'));
			this.options.onDownload(this.model.get('options'), _.bind(function(){
				loader.remove();
				this.removeModal();
			}, this));
		}
	}
});

//Models
PJQ.models.reporting = {};
PJQ.models.reporting.Report = PJQ.models.BaseModel.extend({
	idAttribute: 'reportId',
	endpoint: function () {

	},
	parse: function (model) {
		return model;
	},
	generate: function(data, callback = null){
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'reports'
			},
			{
				endpoint: 'js'
			}
		]);
		PJQ.files.queueDownload(endpoint, {
			data: data,
			templateName: this.get('name'),
			fileName: _.size(this.get('fileName')) > 0 ? this.get('fileName').replace('.', '') : 'export'
		}, function(){
			if(typeof callback === 'function'){
				callback();
			}
		});
	}
});
